import * as d3 from "d3";
import MitMapSelectionService from './MitMapSelectionService.js';

class MitMapPreviewService {
    constructor(svgId, objectDefinitions, selectChangedCallback, highlightChangedCallback, createObjectCallback) {
        this.svg = d3.select(svgId);
        this.data = null;

        this.createObjectCallback = createObjectCallback;

        this.serviceSelection = new MitMapSelectionService(selectChangedCallback, highlightChangedCallback);

        this.objectDefinitions = objectDefinitions;
        this.objectToCreate = null;
        this.editmode = false;

        this.projection = null;
        this.path = null;
        this.zoom = null;

        this.layerMap = null;
        this.layerPrevLevel = null;
        this.layerCurrentLevel = null;
        this.layerObjects = null;

        this.selected = {};//space or object that is currently in focus

        this.colorCodes = {
            'BACKGROUND':'#DDC7A8',
            'GRAY_LIGHT':'#F0F0F0',
            'GRAY_DARK': '#E2E2E2',
            'CORRIDOR':'#E5D5BE',
            'STAIRWAY':'#A5A5A4',
            'ELEVATOR':'#A5A5A4'
        };
    }

    setEditMode(editmode){
        this.editmode = editmode;
    }
    deselect(){
        this.serviceSelection.unselect(this.serviceSelection.currentlySelected.space, this.serviceSelection.currentlySelected.d3Element);
    }

    changeCreateObject(obj){
        this.objectToCreate = obj;

        if(this.objectToCreate){
            this.svg.style("cursor", "crosshair");
        }
        else {
            this.svg.style("cursor", "default");
        }
    }

    addObject(objToCreate, mouseX, mouseY, parentSpace){

        //let transform = d3.zoomTransform(svg.node()); // get the current zoom
        //let xy = transform.invert(d3.mouse(this));

        let p1 = this.projection.invert([mouseX-(objToCreate.width/2),mouseY-(objToCreate.height/2)]);
        let p2 = this.projection.invert([mouseX-(objToCreate.width/2),(mouseY-(objToCreate.height/2))+objToCreate.width]);
        let p3 = this.projection.invert([mouseX-(objToCreate.width/2)+objToCreate.height,(mouseY-(objToCreate.height/2))+objToCreate.width]);
        let p4 = this.projection.invert([mouseX-(objToCreate.width/2)+objToCreate.height,mouseY-(objToCreate.height/2)]);

        let feature = {
                type: "Feature",
                geometry: {
                    type: "Polygon",
                    coordinates: []
                    // coordinates: [
                    //                [
                    //                        [p1[1],p1[0]],
                    //                      [p2[1],p2[0]],
                    //                      [p3[1],p3[0]],
                    //                      [p4[1],p4[0]],
                    //                      [p1[1],p1[0]]
                    //                  ] //p1 again to close the shape
                    //              ]
                },
                properties:{
                    mitId:parentSpace.properties.mitId + '-' + objToCreate.id,
                    mitIdShort:parentSpace.properties.mitIdShort + '-' + objToCreate.id,
                    name:'',
                    level:parentSpace.properties.level,
                    floorId: parentSpace.properties.floorId,
                    sqfoot:'',
                    org:'',
                    useType:objToCreate.id,
                    useCategory:objToCreate.id+'s',
                    spaceType:'object'
                }
        };
        feature.geometry.coordinates.push([ p1,p2,p3,p4,p1])
        //this.data.features.push(feature);

        let createdOject = this.layerCurrentLevel.append("rect");

        createdOject.attr("fill", "url(#"+objToCreate.id+")")
                    .datum(feature)
                    //.attr("style", "filter: opacity(0.5) drop-shadow(0 0 0 blue);")
                    //.attr("style", "border: 5px solid #555;")
                    .attr("cursor", "grab")
                    .attr("color", "red")
                    .attr('x', mouseX-(objToCreate.width/2))
                    .attr('y', mouseY-(objToCreate.height/2))
                    .attr('width', objToCreate.width)
                    .attr('height', objToCreate.height)
                    //.attr("href", "/assets/objects/"+editmodeSelectedObject+".png")
                    //old deprecated method, but might need for support on some browsers
                    //.attr("xlink:href", "/assets/objects/"+editmodeSelectedObject+".png")
                    .on("click", (event, obj) => {
                        if(this.editmode)
                            this.serviceSelection.select(obj, d3.select(event.target));
                        else
                            this.serviceSelection.selectEvent(space, d3.select(event.target));
                    })
                    .on("mouseover", (event, obj) => {
                        if(!this.editmode)
                            this.serviceSelection.highlight(obj, d3.select(event.target));
                    })
                    .on("mouseleave", (event, obj) => {
                        if(!this.editmode)
                            this.serviceSelection.highlight(obj, d3.select(event.target));
                    });

            if(this.editmode){
                createdOject.call(d3.drag()
                    .on("start", function () {
                        d3.select(this)
                        .attr("cursor", "grabbing")
                        .attr("stroke", null)
                        .raise();
                    })
                    .on("drag", function (event, space) {
                        //Update the actual space coordinates here.
                        d3.select(this)
                            .attr('x', event.x-(objToCreate.width/2))
                            .attr('y', event.y-(objToCreate.height/2));
                    })
                    .on("end",  function () {
                        let control = d3.select(this);

                        control.attr("cursor", "grab");

                    })
                );

                this.serviceSelection.select(feature, createdOject)
                this.createObjectCallback(feature, createdOject);
            }

    }

    convertGeoJSONtoMapModel(geoJSON){

        // LAYERS - front end creates for visual
        // spaces
        // structure
        // object - static but selectable
        // object - movable
        // text
        //
        // API - backend returns full geojson
        //      /geojson entire thing with filters
        //      /topojson entire thing with filters
        //
        // MODEL - types in DB
        // building
        //     floor
        //         space
        //             object (printer)
        //         door
        //         window

        let mapModel = {};

        let level;

        for(let x = 0; x < geoJSON.features.length; x++){
            level = geoJSON.features[x].properties.level;

            if(mapModel.hasOwnProperty(level) === false){
                mapModel[level] = {
                    spaces:{
                        "type": "FeatureCollection",
                        "features": []
                    },
                    structures:{
                        "type": "FeatureCollection",
                        "features": []
                    },
                    windows:{
                        "type": "FeatureCollection",
                        "features": []
                    },
                    doors:{
                        "type": "FeatureCollection",
                        "features": []
                    },
                    objects:{
                        "type": "FeatureCollection",
                        "features": []
                    }
                }
            }

            switch(geoJSON.features[x].properties.spaceType){
                case 'floor':
                    mapModel[level].structures.features.push(geoJSON.features[x]);
                    break;
                case 'space':
                    mapModel[level].spaces.features.push(geoJSON.features[x]);
                    break;
                case 'door':
                    mapModel[level].doors.features.push(geoJSON.features[x]);
                    break;
                case 'window':
                    mapModel[level].windows.features.push(geoJSON.features[x]);
                    break;
                case 'object':
                    mapModel[level].objects.features.push(geoJSON.features[x]);
                    break;
            }

        }

        return mapModel;

    }

    enableZoom(zoomInElementId, zoomOutElementId, zoomResetElementId){
        this.zoomControls = {
            in:zoomInElementId,
            out:zoomOutElementId,
            reset:zoomResetElementId
        }

        this.zoom = d3.zoom()
        .scaleExtent([1, 10])
        .on("zoom", function (e) {
            d3.select('svg #group-map').attr('transform',e.transform);
        });

        this.svg.call(this.zoom)
                .on("wheel.zoom", null); //prevent zooming while scrolling

        this.addZoomEvents();
    }

    createMap(mapModel, width, height, selectedFloor, selectedUseTypes, selectedSpace, selectedOrg){
        this.clearMap();

        this.svg.attr("width", width)
                .attr("height", height);

        this.addUIObjectsDefinitions(this.objectDefinitions);

        const combined = {
            "type": "FeatureCollection",
            "features": []
        }
        combined.features = mapModel[selectedFloor].spaces.features.concat(mapModel[selectedFloor].doors.features);

        this.createProjection(combined, width, height);

        this.createLayers(mapModel[selectedFloor], selectedFloor);

        this.renderLayerPrevSpacesLevel(mapModel[selectedFloor-1]);
        this.renderLayerSpacesLevel(mapModel[selectedFloor], selectedFloor, selectedUseTypes, selectedSpace, selectedOrg);
        this.renderLayerStructuresLevel(mapModel[selectedFloor], selectedFloor);
        this.renderLayerWindowsLevel(mapModel[selectedFloor], selectedFloor);
        this.renderLayerDoorsLevel(mapModel[selectedFloor], selectedFloor);

    }

    clearMap(){
        if(this.svg){
            this.svg.selectAll("*").remove();
        }
    }

    addUIObjectsDefinitions(objectList){
        let defs = this.svg.append("defs");

        for(let x = 0; x < objectList.length; x++){
            defs.append('pattern')
                .attr('id', objectList[x].id)
                .attr('width', objectList[x].width)
                .attr('height', objectList[x].height)
                .append("image")
                    .attr("href", objectList[x].imagePath)
                    .attr('width', objectList[x].width)
                    .attr('height', objectList[x].height);
        }

    }

/* ****************************************************
INTERNAL FUNCTIONS
******************************************************* */

    getSpaceColor(spaceProperties){
          return this.colorCodes[spaceProperties.useType];
    }

    addZoomEvents(){
        d3.select(this.zoomControls.in).on("click", () => {
            this.svg.transition().call(this.zoom.scaleBy, 2);
        });
        d3.select(this.zoomControls.out).on("click", () => {
            this.svg.transition().call(this.zoom.scaleBy, 0.5);
        });
        d3.select(this.zoomControls.reset).on("click", () => {
            this.svg.transition().call(this.zoom.scaleTo, 1);
        });
    }

    createProjection(geojson, width, height){
        this.projection = d3.geoMercator()
                      .rotate([90, 28.5, 0])
                      .fitSize([width, height], geojson);

        // Create a GeoPath function from the projection
        this.path = d3.geoPath().projection(this.projection);
    }

    createLayers(){

        //ORDER MATTERS!!!
        this.layerMap = this.svg.append("g").attr("id", "group-map");
        this.layerPrevSpaces = this.layerMap.append("g");
        this.layerSpaces = this.layerMap.append("g");
        this.layerStructure = this.layerMap.append("g");
        this.layerDoors = this.layerMap.append("g");
        this.layerWindows = this.layerMap.append("g");
        this.layerText = this.layerMap.append("g");
    }

    renderLayerStructuresLevel(geojson, selectedFloor){
        if(geojson.structures.features.length === 0)
            return;

        this.layerStructure.selectAll("path")
            .data(geojson.structures.features)
            .enter()
            .append("path")
            .attr("d", (feature) => this.path(feature))
            .attr("stroke", 'black')
            //.attr("fill", null)
            .style("stroke-width", ".5px");
            //.style("opacity", .4);
    }
    renderLayerDoorsLevel(geojson, selectedFloor){
        if(geojson.doors.features.length === 0)
            return;

        this.layerDoors.selectAll("path")
            .data(geojson.doors.features)
            .enter()
            .append("path")
            .attr("d", (feature) => this.path(feature))
            .attr("stroke", '#6D4A33')
            .style("stroke-width", ".5px");
    }

    renderLayerWindowsLevel(geojson, selectedFloor){
        if(geojson.windows.features.length === 0)
            return;

        this.layerWindows.selectAll("path")
            .data(geojson.windows.features)
            .enter()
            .append("path")
            .attr("d", (feature) => this.path(feature))
            .attr("stroke", '#758CB3')
            .style("stroke-width", ".5px");
    }

    renderLayerPrevSpacesLevel(geojson, selectedFloor){
        if(typeof geojson === 'undefined')
            return;

        this.layerPrevSpaces.selectAll("path")
            .data(geojson.spaces.features)
            .enter()
            .append("path")
            .filter((f) => {
                if(typeof f.properties === 'undefined')
                    return false;

                return true;
            })
            .attr("d", (feature) => this.path(feature))
            .attr("stroke", (f) => {
                return "#9F9F9F";
            })
            .attr("fill", (f) => {
                if(this.getSpaceColor(f.properties))
                    return this.getSpaceColor(f.properties);
                else
                    //return this.colorCodes.GRAY_LIGHT
                    return "#EBEBCC"//DCE2E8
            })
            .style("stroke-width", "1px")
            .style("opacity", .6);
    }

    renderLayerSpacesLevel(geojson, selectedFloor, selectedUseTypes, selectedSpace, selectedOrg){
        let mouseOverObject = null;

        this.layerSpaces.selectAll("path")
            .data(geojson.spaces.features)
            .enter()
            .append("path")
            .filter((f) => {
                if(typeof f.properties === 'undefined')
                    return false;
                return true;
            })
            .attr("d", (feature) => this.path(feature))
            .attr("fill", (f) => {
                if(f.properties.useType == selectedUseTypes)
                    return "#F69F88";

                if(f.properties.mitIdShort == selectedSpace)
                    return "#A9F688";
                else if(this.getSpaceColor(f.properties))
                    return this.getSpaceColor(f.properties);
                else{
                    if(selectedOrg == null || f.properties.org == selectedOrg)
                        return 'white';
                        //return 'transparent';
                    else
                        //return this.colorCodes.GRAY_LIGHT;
                        //D7EAFE
                        //DCE2E8
                        //F0F0F0
                        //CCD7E1
                        return "#E8E8E8"

                }

            })
            .attr("opacity", (f) => {
                return 1;
                if(selectedOrg == null || f.properties.org == selectedOrg)
                    return 1;
                else
                    return .4
            })
            .style("stroke-width", "1px")
            .on("mouseover", (event, space) => {
                if(!this.editmode)
                    this.serviceSelection.highlight(space, d3.select(event.target));
            })
            .on("click",  (event, space) => {
                if(this.objectToCreate){
                    let m = d3.pointer(event);
                    this.addObject(this.objectToCreate, m[0], m[1], space);
                }
                else{
                    if(this.editmode)
                        this.serviceSelection.select(space, d3.select(event.target));
                    else
                        this.serviceSelection.selectEvent(space, d3.select(event.target));
                }

                //}
                // else if(this.eventSpaceClickCallback){
                //     this.eventSpaceClickCallback(space.properties, event, d3.select(event.target))
                // }
            })
            // .on("mousemove", (event, space) => {
            //     let element = d3.select(event.target);
            //     let mouse = d3.pointer(event);
            //     d3.select(element)
            //         .attr('x', mouse[0]-5)
            //         .attr('y', mouse[1]-5);
            // })
            // .on("dblclick",  (event, space) => {
            // })
            .on("mouseleave", (event, space) => {
                // this.unselectSpace(space, event);
                if(!this.editmode)
                    this.serviceSelection.unhighlight(space, d3.select(event.target));
            });

            this.layerText.selectAll("text")
                .data(geojson.spaces.features)
                .enter()
                .append("svg:text")
                .filter((f) => {
                    if(typeof f.properties === 'undefined')
                        return false;

                    if(selectedOrg && f.properties.org != selectedOrg)
                        return false;

                    // if(selectedOrg && f.properties.org == selectedOrg && f.properties.level === selectedFloor)
                    //     return true;

                    if(f.properties.level === selectedFloor &&
                        (
                            f.properties.useType == 'OFFICE' ||
                            f.properties.useType == 'LECTURE HALL'||
                            f.properties.useType == 'OFFICE SERVICE'||
                            f.properties.useType == 'RESEARCH LAB'||
                            f.properties.useType == 'RSCH LAB-OFFICE'||
                            f.properties.useType == 'LABORATORY SERVICE'||
                            f.properties.useType == 'LABORATORY SVC'||
                            f.properties.useType == 'SECY/RECEPTION'||
                            f.properties.useType == 'LAB SUPPORT SHOP'||
                            f.properties.useType == 'CLASSROOM'||
                            f.properties.useType == 'CLASSROOM SVC'||
                            f.properties.useType == 'COMPUTER FACIL'||
                            f.properties.useType == 'COMPUTER SERVICE'||
                            f.properties.useType == 'LOUNGE'||
                            f.properties.useType == 'CONFERENCE ROOM'
                        )
                    )
                        return true;

                    return false;
                })
                .text((d) => {
                    return d.properties.mitIdShort;
                })
                .attr("x", (d) => {
                    return this.path.centroid(d)[0];
                })
                .attr("y", (d) => {
                    return  this.path.centroid(d)[1];
                })
                .attr("text-anchor","middle")
                .attr('font-size','4pt')
                .call(function getBB(selection) {
                    selection.each(function(d){d.bbox = this.getBBox();})
                });

            this.layerText.selectAll("rect")
                .data(geojson.spaces.features)
                .enter()
                .append("svg:rect")
                .filter((f) => {
                    if(typeof f.properties === 'undefined')
                        return false;

                    if(selectedOrg && f.properties.org != selectedOrg)
                        return false;

                    // if(selectedOrg && f.properties.org == selectedOrg && f.properties.level === selectedFloor)
                    //     return true;

                    if(f.properties.level === selectedFloor &&
                        (
                            f.properties.useType == 'OFFICE' ||
                            f.properties.useType == 'LECTURE HALL'||
                            f.properties.useType == 'OFFICE SERVICE'||
                            f.properties.useType == 'RESEARCH LAB'||
                            f.properties.useType == 'RSCH LAB-OFFICE'||
                            f.properties.useType == 'LABORATORY SERVICE'||
                            f.properties.useType == 'LABORATORY SVC'||
                            f.properties.useType == 'SECY/RECEPTION'||
                            f.properties.useType == 'LAB SUPPORT SHOP'||
                            f.properties.useType == 'CLASSROOM'||
                            f.properties.useType == 'CLASSROOM SVC'||
                            f.properties.useType == 'COMPUTER FACIL'||
                            f.properties.useType == 'COMPUTER SERVICE'||
                            f.properties.useType == 'LOUNGE'||
                            f.properties.useType == 'CONFERENCE ROOM'
                        )
                    )
                        return true;

                    return false;
                })
                .attr("x", function(d){return d.bbox.x})
                .attr("y", function(d){return d.bbox.y})
                .attr("width", function(d){return d.bbox.width})
                .attr("height", function(d){return d.bbox.height})
                .attr("fill","white");

                //raise the text back on top of the rectangles we just drew
                this.layerText.selectAll("text").raise()
                .call(function getBB(selection) {
                    selection.each(function(d){delete d.bbox;})
                });
    }
    renderLayerObjects(geojson){

    }

}

export default MitMapPreviewService;
